import type { RouteRecordRaw } from 'vue-router';

// Native account pages (migrated out of the legacy sub). All three are native
// now, so `/account` is dropped from LEGACY_OWNED_PATHS — these routes fully own
// the prefix.
const accountRoutes: RouteRecordRaw[] = [
  {
    // Bare /account (the sidebar group header targets it) → setting, matching
    // the legacy `/account` parent redirect. Without the legacy catch-all this
    // is what keeps a bare /account hit from falling through to not-found.
    path: '/account',
    redirect: '/account/setting',
  },
  {
    path: '/account/organization',
    name: 'account-organization',
    component: () => import('@/domains/account/views/OrganizationView.vue'),
    meta: { renderer: 'native' },
  },
  {
    // Admin-only (legacy route gated on the allObj@allAct passport); a
    // non-admin lands on the in-place permission-denied page.
    path: '/account/audit-log',
    name: 'account-audit-log',
    component: () => import('@/domains/account/views/AuditLogView.vue'),
    meta: { renderer: 'native', perms: ['allObj@allAct'] },
  },
  {
    // Overview is visible to all; the sso / advanced tabs gate on isAdmin
    // internally (legacy had no route-level perms here).
    path: '/account/setting',
    name: 'account-setting',
    component: () => import('@/domains/account/views/SettingView.vue'),
    meta: { renderer: 'native' },
  },
];

export default accountRoutes;
